import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.32948 3.43435L8.94554 5.19173C9.11962 5.30728 9.06975 5.57965 8.86363 5.62696L5.78113 6.259C5.7195 6.27668 5.66565 6.30789 5.63019 6.35549L3.88248 8.98245C3.76757 9.15725 3.49641 9.10697 3.44919 8.89987L2.81808 5.80285C2.80045 5.74093 2.76935 5.68681 2.72194 5.65116L0.105884 3.89378C-0.0681904 3.77823 -0.0183216 3.50585 0.187797 3.45855L3.27029 2.82649C3.33192 2.80881 3.38577 2.77761 3.42123 2.73001L5.17957 0.105926C5.29448 -0.0688745 5.56564 -0.0186094 5.61285 0.188485L6.24396 3.28552C6.2616 3.34744 6.29269 3.40155 6.3401 3.4372L6.32948 3.43435Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
